import { coreTagsLinkPostAsyncSlice } from './post';

export const { requestPostCoreTagsLink, resetPostCoreTagsLink } = coreTagsLinkPostAsyncSlice.asyncActionCreators;
